import { render, staticRenderFns } from "./UsuarioModal.vue?vue&type=template&id=1a4f85c6&scoped=true"
import script from "./UsuarioModal.vue?vue&type=script&lang=js"
export * from "./UsuarioModal.vue?vue&type=script&lang=js"
import style0 from "./UsuarioModal.vue?vue&type=style&index=0&id=1a4f85c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4f85c6",
  null
  
)

export default component.exports